export const APP_VERSION = "1.3.1";

/**
 * Formato de exibição da versão
 * @param withPrefix - Se true, adiciona "v" antes da versão (ex: "v1.0.0")
 * @returns A versão formatada
 */
export const getFormattedVersion = (withPrefix: boolean = true): string => {
  return withPrefix ? `v${APP_VERSION}` : APP_VERSION;
};
